import { useMemo } from 'react';

import api from "@/api";

import {useNavigate} from "react-router-dom";
import { observer } from "mobx-react-lite";

import { getRoleName } from '@/utils/role';

import { authStore } from "@/store/auth";
import { storeUser } from "@/store/user";

import { UserOutlined } from "@ant-design/icons";
import { Dropdown } from 'antd'

import { dropDownMenu } from './constants'

import './styles/header-user.scss'

function HeaderUser() {
    const navigate = useNavigate();

    const logout = () => {
        authStore.logout();
        storeUser.logout();

        api.auth.logout()

        navigate("/login");
    }

    const handleClickMenu = (item:unknown) => {
        if(!item.key) {
            return
        }

        switch(item.key) {
            case 'domains':
                navigate('/studio/domains');
                break;
            case 'docs':
                navigate('/docs');
                break;
            case 'logout':
                logout();
                break;
        }
    }

    const roleName = useMemo(() => {
        return getRoleName(storeUser.userRole)
    }, [storeUser.userRole])

    return (
        <div className={'header-user'}>
            <Dropdown menu={{items: dropDownMenu, onClick: handleClickMenu}}>
                <div>
                    <UserOutlined className={'header-user__icon'} />
                    <div className={'header-user__role-name'}>{roleName}</div>
                </div>
            </Dropdown>
        </div>
    )
}

export default observer(HeaderUser)